import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  FaPowerOff,
  FaHistory,
  FaClipboardList,
  FaCoins,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaPlayCircle,
  FaStopCircle,
  FaUserTie,
  FaTools,
  FaCity,
  FaMapMarkedAlt,
  FaBriefcase,
  FaPhoneAlt,
  FaIdBadge,
} from 'react-icons/fa';
import CONFIG from './../../config.js';

const LabourDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const labour_name =
    location.state?.labour_name || sessionStorage.getItem('labourName') || 'Unknown Agent';
  const labour_id =
    location.state?.labour_id || sessionStorage.getItem('labour_id') || '';
  const mobile_number =
    location.state?.mobile_number || sessionStorage.getItem('mobile') || '';
  const Total_credit_Point = location.state?.Total_credit_Point || '0';

  const [showModal, setShowModal] = useState(false);
  const [labourProfile, setLabourProfile] = useState(null);
  const [orders, setOrders] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [oldOrderHistory, setOldOrderHistory] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [loadingOldHistory, setLoadingOldHistory] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    accountHolder: '',
    bankName: '',
    accountNumber: '',
    ifscCode: '',
  });

  const styles = {
    page: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #eef4ff 0%, #f8fbff 45%, #f1f5f9 100%)',
      padding: '24px 0 40px',
      fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    container: {
      width: '95%',
      maxWidth: '1450px',
      margin: '0 auto',
    },
    hero: {
      background: 'linear-gradient(135deg, #0f172a 0%, #1d4ed8 55%, #60a5fa 100%)',
      borderRadius: '28px',
      padding: '30px',
      color: '#fff',
      boxShadow: '0 18px 40px rgba(37, 99, 235, 0.22)',
      marginBottom: '24px',
      position: 'relative',
      overflow: 'hidden',
    },
    badge: {
      display: 'inline-block',
      padding: '7px 14px',
      borderRadius: '999px',
      background: 'rgba(255,255,255,0.16)',
      border: '1px solid rgba(255,255,255,0.18)',
      fontSize: '12px',
      fontWeight: '700',
      marginBottom: '12px',
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
    },
    title: {
      fontSize: '2rem',
      fontWeight: '800',
      margin: 0,
      letterSpacing: '-0.02em',
    },
    subtitle: {
      marginTop: '10px',
      marginBottom: 0,
      color: 'rgba(255,255,255,0.9)',
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    heroMiniWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      marginTop: '16px',
    },
    heroMiniPill: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: 'rgba(255,255,255,0.12)',
      border: '1px solid rgba(255,255,255,0.15)',
      color: '#fff',
      borderRadius: '999px',
      padding: '9px 14px',
      fontSize: '13px',
      fontWeight: '600',
    },
    logoutBtn: {
      border: 'none',
      background: '#ef4444',
      color: '#fff',
      borderRadius: '999px',
      padding: '12px 24px',
      fontWeight: '700',
      minWidth: '170px',
      boxShadow: '0 10px 22px rgba(239,68,68,0.28)',
      cursor: 'pointer',
    },
    statCard: {
      background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
      borderRadius: '24px',
      padding: '24px',
      boxShadow: '0 10px 28px rgba(15, 23, 42, 0.08)',
      border: '1px solid #e6eef8',
      height: '100%',
    },
    creditCard: {
      background: 'linear-gradient(135deg, #15803d 0%, #16a34a 55%, #4ade80 100%)',
      color: '#fff',
      borderRadius: '24px',
      padding: '24px',
      boxShadow: '0 14px 30px rgba(22,163,74,0.22)',
      height: '100%',
    },
    statTitle: {
      fontSize: '15px',
      fontWeight: '700',
      marginBottom: '8px',
      color: '#334155',
    },
    statValue: {
      fontSize: '2rem',
      fontWeight: '800',
      marginBottom: '8px',
      lineHeight: 1.1,
    },
    statText: {
      marginBottom: '16px',
      color: 'inherit',
      opacity: 0.92,
      fontSize: '14px',
      lineHeight: 1.6,
    },
    claimBtn: {
      background: '#fff',
      color: '#15803d',
      border: 'none',
      borderRadius: '999px',
      padding: '10px 18px',
      fontWeight: '800',
      cursor: 'pointer',
      boxShadow: '0 8px 18px rgba(255,255,255,0.18)',
    },
    sectionCard: {
      background: 'rgba(255,255,255,0.95)',
      borderRadius: '28px',
      padding: '24px',
      boxShadow: '0 14px 30px rgba(15, 23, 42, 0.07)',
      border: '1px solid #e9eef5',
      marginBottom: '24px',
      backdropFilter: 'blur(8px)',
    },
    sectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '18px',
      flexWrap: 'wrap',
      gap: '10px',
    },
    sectionTitle: {
      margin: 0,
      fontSize: '1.45rem',
      fontWeight: '800',
      color: '#0f172a',
      letterSpacing: '-0.02em',
    },
    sectionPill: {
      background: '#eef4ff',
      color: '#1d4ed8',
      padding: '7px 14px',
      borderRadius: '999px',
      fontWeight: '700',
      fontSize: '12px',
      letterSpacing: '0.03em',
    },

    profileHero: {
      background: 'linear-gradient(135deg, #eff6ff 0%, #f8fbff 55%, #ffffff 100%)',
      border: '1px solid #dbeafe',
      borderRadius: '24px',
      padding: '22px',
      marginBottom: '18px',
    },
    profileHeroTop: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '16px',
    },
    profileIdentity: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      flexWrap: 'wrap',
    },
    avatarCircle: {
      width: '72px',
      height: '72px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #1d4ed8, #60a5fa)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '28px',
      boxShadow: '0 10px 24px rgba(37, 99, 235, 0.22)',
      flexShrink: 0,
    },
    profileName: {
      margin: 0,
      fontSize: '1.35rem',
      fontWeight: '800',
      color: '#0f172a',
    },
    profileSubText: {
      margin: '6px 0 0 0',
      color: '#475569',
      fontSize: '14px',
      lineHeight: 1.7,
    },
    profileStatusBox: {
      background: '#fff',
      border: '1px solid #dbeafe',
      borderRadius: '18px',
      padding: '14px 18px',
      minWidth: '220px',
      boxShadow: '0 8px 18px rgba(59, 130, 246, 0.08)',
    },
    profileStatusLabel: {
      fontSize: '11px',
      textTransform: 'uppercase',
      color: '#64748b',
      fontWeight: '800',
      letterSpacing: '0.08em',
      marginBottom: '8px',
    },
    profileStatusBadge: (active) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '999px',
      padding: '8px 14px',
      fontSize: '13px',
      fontWeight: '800',
      background: active ? '#dcfce7' : '#fee2e2',
      color: active ? '#166534' : '#b91c1c',
    }),
    profileQuickStats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
      gap: '14px',
      marginBottom: '16px',
    },
    quickStatCard: {
      background: '#ffffff',
      border: '1px solid #e5eefb',
      borderRadius: '18px',
      padding: '16px',
      boxShadow: '0 8px 18px rgba(15,23,42,0.04)',
    },
    quickStatIconWrap: {
      width: '40px',
      height: '40px',
      borderRadius: '12px',
      background: '#eff6ff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#2563eb',
      marginBottom: '12px',
    },
    quickStatLabel: {
      fontSize: '12px',
      fontWeight: '800',
      color: '#64748b',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '6px',
    },
    quickStatValue: {
      fontSize: '15px',
      color: '#0f172a',
      fontWeight: '700',
      wordBreak: 'break-word',
      lineHeight: 1.6,
    },
    profileGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
      gap: '16px',
    },
    profileItem: {
      background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
      border: '1px solid #e6eef8',
      borderRadius: '20px',
      padding: '18px',
      boxShadow: '0 10px 18px rgba(15, 23, 42, 0.05)',
      minHeight: '140px',
    },
    profileLabel: {
      fontSize: '12px',
      color: '#64748b',
      fontWeight: '800',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
    },
    profileValue: {
      fontSize: '15px',
      color: '#0f172a',
      fontWeight: '700',
      wordBreak: 'break-word',
      lineHeight: 1.7,
    },
    chipWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '4px',
    },
    chip: {
      display: 'inline-flex',
      alignItems: 'center',
      background: '#eef4ff',
      color: '#1e40af',
      border: '1px solid #dbeafe',
      padding: '8px 12px',
      borderRadius: '999px',
      fontSize: '13px',
      fontWeight: '700',
      lineHeight: 1.3,
    },
    workStatusGood: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: '#dcfce7',
      color: '#166534',
      borderRadius: '999px',
      padding: '8px 12px',
      fontSize: '13px',
      fontWeight: '800',
    },
    workStatusIdle: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: '#fef3c7',
      color: '#92400e',
      borderRadius: '999px',
      padding: '8px 12px',
      fontSize: '13px',
      fontWeight: '800',
    },

    tableWrap: {
      overflowX: 'auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'separate',
      borderSpacing: 0,
      minWidth: '1450px',
    },
    th: {
      background: '#f8fafc',
      color: '#334155',
      padding: '14px',
      textAlign: 'left',
      borderBottom: '1px solid #e5e7eb',
      fontSize: '13px',
      fontWeight: '800',
      whiteSpace: 'nowrap',
    },
    td: {
      padding: '14px',
      borderBottom: '1px solid #edf2f7',
      color: '#374151',
      fontSize: '14px',
      verticalAlign: 'middle',
      background: '#fff',
    },
    priceText: {
      color: '#111827',
      fontWeight: '800',
      whiteSpace: 'nowrap',
    },
    acceptBtn: {
      border: 'none',
      background: '#16a34a',
      color: '#fff',
      borderRadius: '999px',
      padding: '10px 18px',
      fontWeight: '700',
      marginRight: '10px',
      cursor: 'pointer',
      boxShadow: '0 8px 18px rgba(22,163,74,0.18)',
    },
    rejectBtn: {
      border: '1px solid #ef4444',
      background: '#fff',
      color: '#ef4444',
      borderRadius: '999px',
      padding: '10px 18px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    startBtn: {
      border: 'none',
      background: '#2563eb',
      color: '#fff',
      borderRadius: '999px',
      padding: '8px 16px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    stopBtn: {
      border: 'none',
      background: '#f59e0b',
      color: '#fff',
      borderRadius: '999px',
      padding: '8px 16px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    cancelBtn: {
      border: 'none',
      background: '#dc2626',
      color: '#fff',
      borderRadius: '999px',
      padding: '8px 16px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    completedText: {
      color: '#16a34a',
      fontWeight: '800',
    },
    waitingText: {
      color: '#6b7280',
      fontWeight: '700',
    },
    emptyText: {
      color: '#6b7280',
      margin: 0,
      padding: '12px 0',
      fontSize: '15px',
    },
    statusBadge: {
      display: 'inline-block',
      padding: '7px 12px',
      borderRadius: '999px',
      background: '#d1fae5',
      color: '#047857',
      fontWeight: '800',
      fontSize: '12px',
    },
    statusStarted: {
      display: 'inline-block',
      padding: '7px 12px',
      borderRadius: '999px',
      background: '#ede9fe',
      color: '#6d28d9',
      fontWeight: '800',
      fontSize: '12px',
    },
    statusCompleted: {
      display: 'inline-block',
      padding: '7px 12px',
      borderRadius: '999px',
      background: '#e0f2fe',
      color: '#0369a1',
      fontWeight: '800',
      fontSize: '12px',
    },
    statusCancelled: {
      display: 'inline-block',
      padding: '7px 12px',
      borderRadius: '999px',
      background: '#fee2e2',
      color: '#b91c1c',
      fontWeight: '800',
      fontSize: '12px',
    },
    modalBackdrop: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(15,23,42,0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '16px',
    },
    modalBox: {
      width: '100%',
      maxWidth: '500px',
      background: '#fff',
      borderRadius: '24px',
      padding: '24px',
      boxShadow: '0 20px 45px rgba(0,0,0,0.2)',
    },
    input: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: '12px',
      border: '1px solid #d1d5db',
      outline: 'none',
      marginBottom: '12px',
      fontSize: '14px',
    },
    modalFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
      marginTop: '10px',
      flexWrap: 'wrap',
    },
    secondaryBtn: {
      border: 'none',
      background: '#6c757d',
      color: '#fff',
      borderRadius: '10px',
      padding: '10px 16px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    primaryBtn: {
      border: 'none',
      background: '#0d6efd',
      color: '#fff',
      borderRadius: '10px',
      padding: '10px 16px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    subList: {
      margin: '6px 0 0 0',
      paddingLeft: '18px',
      color: '#4b5563',
      fontSize: '13px',
    },
  };

  const START_BUFFER_MINUTES = Number(CONFIG.JOB_START_BUFFER_MINUTES || 30);
  const LABOUR_CANCEL_BEFORE_HOURS = Number(CONFIG.LABOUR_CANCEL_BEFORE_HOURS || 1);

  const safeJoin = (value) => (Array.isArray(value) ? value.join(', ') : value || '-');

  const toArray = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'string' && value.trim()) {
      return value.split(',').map((item) => item.trim()).filter(Boolean);
    }
    return [];
  };

  const parseJobDateTime = (job) => {
    if (!job?.date || !job?.time) return null;

    const rawDate = String(job.date).trim();
    const rawTime = String(job.time).trim().toLowerCase();

    const dateMatch = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!dateMatch) return null;

    const year = parseInt(dateMatch[1], 10);
    const month = parseInt(dateMatch[2], 10) - 1;
    const day = parseInt(dateMatch[3], 10);

    let firstTime = rawTime;
    if (firstTime.includes('-')) {
      firstTime = firstTime.split('-')[0].trim();
    }

    firstTime = firstTime.replace(/\s+/g, '');

    let hours = 0;
    let minutes = 0;

    const match12 = firstTime.match(/^(\d{1,2})(?::(\d{2}))?(am|pm)$/i);
    const match24 = firstTime.match(/^(\d{1,2}):(\d{2})$/);

    if (match12) {
      hours = parseInt(match12[1], 10);
      minutes = parseInt(match12[2] || '0', 10);
      const meridian = match12[3].toLowerCase();

      if (hours < 1 || hours > 12 || minutes < 0 || minutes > 59) return null;

      if (meridian === 'pm' && hours !== 12) hours += 12;
      if (meridian === 'am' && hours === 12) hours = 0;
    } else if (match24) {
      hours = parseInt(match24[1], 10);
      minutes = parseInt(match24[2], 10);

      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
    } else {
      return null;
    }

    return new Date(year, month, day, hours, minutes, 0, 0);
  };

  const getReadableWorkStatus = () => {
    const raw = String(labourProfile?.work_status ?? labourProfile?.workstatus ?? '0').toLowerCase();

    if (raw === '1' || raw === 'active' || raw === 'started' || raw === 'online') {
      return { label: 'Available for Work', active: true };
    }

    if (raw === '777') {
      return { label: 'Work in Progress', active: true };
    }

    return { label: 'Idle / Offline', active: false };
  };

  const handleCancelOrder = async (job) => {
    try {
      const validation = getCancelValidation(job);
      if (!validation.allowed) {
        alert(validation.message);
        return;
      }

      const pid = job?.pid || '';
      const orderId = job?.order_id || job?._id || '';

      if (!pid) {
        console.log('Cancel job payload issue:', job);
        alert('PID not found for this order. Please refresh and try again.');
        return;
      }

      const confirmCancel = window.confirm(
        `Are you sure you want to cancel this order? You can cancel only before ${LABOUR_CANCEL_BEFORE_HOURS} hour(s) from the job time.`
      );

      if (!confirmCancel) return;

      const payload = {
        pid: String(pid),
        order_id: String(orderId),
        labour_id: labour_id || labourProfile?.labour_id || '',
        labour_name: labour_name || labourProfile?.labour_name || '',
        labour_mobile_number: mobile_number || '',
      };

      const response = await fetch(`${CONFIG.API_BASE_URL}/api/labour/labour-cancel-order/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || 'Order cancelled successfully');
        await fetchOrders();
        await fetchOrderHistory();
        await fetchOldOrderHistory();
      } else {
        alert(data.message || 'Failed to cancel order');
      }
    } catch (error) {
      console.error('Error during cancel order:', error);
      alert('Error while trying to cancel order');
    }
  };

  const getStartValidation = (job) => {
    const jobDateTime = parseJobDateTime(job);

    if (!jobDateTime || Number.isNaN(jobDateTime.getTime())) {
      return { allowed: false, message: 'Invalid job date/time' };
    }

    const now = new Date();
    const diffMinutes = (jobDateTime.getTime() - now.getTime()) / (1000 * 60);

    if (diffMinutes > START_BUFFER_MINUTES) {
      return {
        allowed: false,
        message: `You can start only within ${START_BUFFER_MINUTES} minutes before job time`,
      };
    }

    if (diffMinutes < -1440) {
      return {
        allowed: false,
        message: 'This job start window has expired',
      };
    }

    return { allowed: true, message: '' };
  };

  const getCancelValidation = (job) => {
    const jobDateTime = parseJobDateTime(job);

    if (!jobDateTime || Number.isNaN(jobDateTime.getTime())) {
      return { allowed: false, message: 'Invalid job date/time' };
    }

    const now = new Date();
    const cutoffTime = new Date(
      jobDateTime.getTime() - LABOUR_CANCEL_BEFORE_HOURS * 60 * 60 * 1000
    );

    if (now > cutoffTime) {
      return {
        allowed: false,
        message: `Cancellation allowed only before ${LABOUR_CANCEL_BEFORE_HOURS} hour(s) from job time`,
      };
    }

    return { allowed: true, message: '' };
  };

  const getHistoryStatusBadge = (job) => {
    const value = String(job.status);

    if (value === '2') return <span style={styles.statusBadge}>Accepted</span>;
    if (value === '777') return <span style={styles.statusStarted}>Work Started</span>;
    if (value === '8') return <span style={styles.statusCompleted}>Work Completed</span>;
    if (value === '10' || value === '11') return <span style={styles.statusCancelled}>Cancelled</span>;

    return <span style={styles.waitingText}>{job.status_label || value}</span>;
  };

  const getWorkAction = (job) => {
    const value = String(job.status);
    const workStatus = String(job.work_status || '').toLowerCase();

    if (value === '8' || workStatus === 'stopped') {
      return { type: 'completed', label: 'Completed' };
    }

    if (value === '777' || workStatus === 'started') {
      return { type: 'stop', label: 'Stop' };
    }

    if (value === '2') {
      const validation = getStartValidation(job);
      return {
        type: 'start',
        label: 'Start',
        disabled: !validation.allowed,
        message: validation.message,
      };
    }

    return { type: 'none', label: '-' };
  };

  const formatPrice = (value) => {
    const num = Number(value || 0);
    return `₹ ${num}`;
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/api/labour/labour-logout/`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        alert('Logout successful!');
        sessionStorage.clear();
        navigate('/labour_login');
      } else {
        alert('Logout failed!');
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const fetchOrders = async () => {
    try {
      setLoadingOrders(true);

      const response = await fetch(
        `${CONFIG.API_BASE_URL}/api/labour/labour-orders/${mobile_number}/`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        }
      );

      const data = await response.json();

      if (response.ok) {
        setLabourProfile(data.labour || null);
        setOrders(data.orders || []);
      } else {
        setLabourProfile(null);
        setOrders([]);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setLabourProfile(null);
      setOrders([]);
    } finally {
      setLoadingOrders(false);
    }
  };

  const fetchOrderHistory = async () => {
    try {
      setLoadingHistory(true);

      const response = await fetch(
        `${CONFIG.API_BASE_URL}/api/labour/labour-order-history/${mobile_number}/`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        }
      );

      const data = await response.json();

      if (response.ok) {
        setOrderHistory(data.orders || []);
      } else {
        setOrderHistory([]);
      }
    } catch (error) {
      console.error('Error fetching order history:', error);
      setOrderHistory([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  const fetchOldOrderHistory = async () => {
    try {
      setLoadingOldHistory(true);

      const response = await fetch(
        `${CONFIG.API_BASE_URL}/api/labour/labour-old-order-history/${mobile_number}/`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        }
      );

      const data = await response.json();

      if (response.ok) {
        setOldOrderHistory(data.orders || []);
      } else {
        setOldOrderHistory([]);
      }
    } catch (error) {
      console.error('Error fetching old order history:', error);
      setOldOrderHistory([]);
    } finally {
      setLoadingOldHistory(false);
    }
  };

  useEffect(() => {
    if (mobile_number) {
      fetchOrders();
      fetchOrderHistory();
      fetchOldOrderHistory();
    }
  }, [mobile_number]);

  const handleOrderAction = async (job, action) => {
    try {
      const effectiveLabourId = labour_id || labourProfile?.labour_id || '';
      const effectiveLabourName = labour_name || labourProfile?.labour_name || '';

      if (!effectiveLabourId) {
        alert('Labour ID not found. Please login again.');
        return;
      }

      const response = await fetch(`${CONFIG.API_BASE_URL}/api/labour/labour-order-action/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          order_id: job.order_id,
          pid: job.pid || '',
          action,
          labour_id: effectiveLabourId,
          labour_name: effectiveLabourName,
          labour_mobile_number: mobile_number,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || `Order ${action} successfully`);
        setOrders((prev) => prev.filter((o) => o.order_id !== job.order_id));
        await fetchOrderHistory();
        await fetchOldOrderHistory();
      } else {
        alert(data.message || `Failed to ${action} order`);
      }
    } catch (error) {
      console.error(`Error during ${action}:`, error);
      alert(`Error while trying to ${action} order`);
    }
  };

  const handleWorkStatus = async (job, action) => {
    try {
      if (action === 'start') {
        const validation = getStartValidation(job);
        if (!validation.allowed) {
          alert(validation.message);
          return;
        }
      }

      const response = await fetch(`${CONFIG.API_BASE_URL}/api/labour/labour-work-status/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          order_id: job.order_id,
          pid: job.pid || '',
          action,
          labour_id: labour_id || labourProfile?.labour_id || '',
          labour_name: labour_name || labourProfile?.labour_name || '',
          labour_mobile_number: mobile_number,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || `Work ${action} successful`);
        await fetchOrderHistory();
        await fetchOldOrderHistory();
      } else {
        alert(data.message || `Failed to ${action} work`);
      }
    } catch (error) {
      console.error(`Error during work ${action}:`, error);
      alert(`Error while trying to ${action} work`);
    }
  };

  const handleClaimSubmit = async () => {
    try {
      const payload = {
        labour_id: labour_id || labourProfile?.labour_id || '',
        labour_name: labour_name || labourProfile?.labour_name || '',
        ...bankDetails,
      };

      const response = await fetch(`${CONFIG.API_BASE_URL}/api/labour/labour-creditclaim/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert('Claim submitted successfully!');
        setShowModal(false);
        setBankDetails({
          accountHolder: '',
          bankName: '',
          accountNumber: '',
          ifscCode: '',
        });
      } else {
        alert('Failed to submit claim.');
      }
    } catch (error) {
      console.error('Error submitting claim:', error);
    }
  };

  const handleInputChange = (e) => {
    setBankDetails({ ...bankDetails, [e.target.name]: e.target.value });
  };

  const workStatusMeta = getReadableWorkStatus();

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.hero}>
          <div className="row align-items-center g-3">
            <div className="col-lg-8">
              <span style={styles.badge}>Labour Dashboard</span>
              <h2 style={styles.title}>Welcome, {labourProfile?.labour_name || labour_name}</h2>
              <p style={styles.subtitle}>
                Manage live bookings, accepted jobs, completed work, cancelled jobs, and your
                profile details in one place.
              </p>

              <div style={styles.heroMiniWrap}>
                <span style={styles.heroMiniPill}>
                  <FaIdBadge />
                  ID: {labourProfile?.labour_id || labour_id || '-'}
                </span>
                <span style={styles.heroMiniPill}>
                  <FaPhoneAlt />
                  Mobile: {labourProfile?.mobile_number || mobile_number || '-'}
                </span>
                <span style={styles.heroMiniPill}>
                  <FaBriefcase />
                  Total Jobs: {orderHistory.length + oldOrderHistory.length}
                </span>
              </div>
            </div>

            <div className="col-lg-4 text-lg-end">
              <button style={styles.logoutBtn} onClick={handleLogout}>
                <FaPowerOff className="me-2" />
                Logout
              </button>
            </div>
          </div>
        </div>

        {labourProfile && (
          <div style={styles.sectionCard}>
            <div style={styles.sectionHeader}>
              <h3 style={styles.sectionTitle}>Labour Profile</h3>
              <span style={styles.sectionPill}>Matched Filters</span>
            </div>

            <div style={styles.profileHero}>
              <div style={styles.profileHeroTop}>
                <div style={styles.profileIdentity}>
                  <div style={styles.avatarCircle}>
                    <FaUserTie />
                  </div>

                  <div>
                    <h4 style={styles.profileName}>
                      {labourProfile?.labour_name || labour_name || 'Labour Partner'}
                    </h4>
                    <p style={styles.profileSubText}>
                      Skilled labour profile matched by service category, service type, city, and
                      preferred areas for booking visibility.
                    </p>
                  </div>
                </div>

                <div style={styles.profileStatusBox}>
                  <div style={styles.profileStatusLabel}>Current Work Status</div>
                  <span style={styles.profileStatusBadge(workStatusMeta.active)}>
                    <FaBriefcase />
                    {workStatusMeta.label}
                  </span>
                </div>
              </div>
            </div>

            <div style={styles.profileQuickStats}>
              <div style={styles.quickStatCard}>
                <div style={styles.quickStatIconWrap}>
                  <FaTools />
                </div>
                <div style={styles.quickStatLabel}>Service Category</div>
                <div style={styles.quickStatValue}>{labourProfile.service_category || '-'}</div>
              </div>

              <div style={styles.quickStatCard}>
                <div style={styles.quickStatIconWrap}>
                  <FaBriefcase />
                </div>
                <div style={styles.quickStatLabel}>Service Type</div>
                <div style={styles.quickStatValue}>{labourProfile.service_type || '-'}</div>
              </div>

              <div style={styles.quickStatCard}>
                <div style={styles.quickStatIconWrap}>
                  <FaCity />
                </div>
                <div style={styles.quickStatLabel}>City</div>
                <div style={styles.quickStatValue}>{labourProfile.city || '-'}</div>
              </div>

              <div style={styles.quickStatCard}>
                <div style={styles.quickStatIconWrap}>
                  <FaMapMarkedAlt />
                </div>
                <div style={styles.quickStatLabel}>Coverage Areas</div>
                <div style={styles.quickStatValue}>{toArray(labourProfile.area).length}</div>
              </div>
            </div>

            <div style={styles.profileGrid}>
              <div style={styles.profileItem}>
                <div style={styles.profileLabel}>Service List</div>
                {toArray(labourProfile.service_list).length > 0 ? (
                  <div style={styles.chipWrap}>
                    {toArray(labourProfile.service_list).map((item, index) => (
                      <span key={`${item}-${index}`} style={styles.chip}>
                        {item}
                      </span>
                    ))}
                  </div>
                ) : (
                  <div style={styles.profileValue}>-</div>
                )}
              </div>

              <div style={styles.profileItem}>
                <div style={styles.profileLabel}>Area</div>
                {toArray(labourProfile.area).length > 0 ? (
                  <div style={styles.chipWrap}>
                    {toArray(labourProfile.area).map((item, index) => (
                      <span key={`${item}-${index}`} style={styles.chip}>
                        {item}
                      </span>
                    ))}
                  </div>
                ) : (
                  <div style={styles.profileValue}>-</div>
                )}
              </div>

              <div style={styles.profileItem}>
                <div style={styles.profileLabel}>Work Status</div>
                <div>
                  {workStatusMeta.active ? (
                    <span style={styles.workStatusGood}>{workStatusMeta.label}</span>
                  ) : (
                    <span style={styles.workStatusIdle}>{workStatusMeta.label}</span>
                  )}
                </div>
              </div>

              <div style={styles.profileItem}>
                <div style={styles.profileLabel}>Labour Details</div>
                <div style={styles.profileValue}>
                  <div>Name: {labourProfile?.labour_name || labour_name || '-'}</div>
                  <div>Labour ID: {labourProfile?.labour_id || labour_id || '-'}</div>
                  <div>Mobile: {labourProfile?.mobile_number || mobile_number || '-'}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row g-4 mb-4">
          <div className="col-md-4">
            <div style={styles.creditCard}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 style={{ margin: 0, fontWeight: '800' }}>Credit Points</h5>
                <FaCoins size={26} />
              </div>
              <div style={styles.statValue}>{Total_credit_Point}</div>
              <p style={styles.statText}>Claim available only above 100 points.</p>
              <button
                style={styles.claimBtn}
                onClick={() => {
                  if (Number(Total_credit_Point) > 100) {
                    setShowModal(true);
                  } else {
                    alert('You should have more than 100 points to claim.');
                  }
                }}
              >
                Claim Credits
              </button>
            </div>
          </div>

          <div className="col-md-4">
            <div style={styles.statCard}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 style={styles.statTitle}>Pending Orders</h5>
                <FaClipboardList size={24} color="#2563eb" />
              </div>
              <div style={{ ...styles.statValue, color: '#111827' }}>{orders.length}</div>
              <p style={{ ...styles.statText, color: '#64748b' }}>
                Matching live booking requests for your profile.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div style={styles.statCard}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 style={styles.statTitle}>Order History</h5>
                <FaHistory size={24} color="#16a34a" />
              </div>
              <div style={{ ...styles.statValue, color: '#111827' }}>
                {orderHistory.length + oldOrderHistory.length}
              </div>
              <p style={{ ...styles.statText, color: '#64748b' }}>
                Accepted, active, completed, and cancelled jobs.
              </p>
            </div>
          </div>
        </div>

        <div style={styles.sectionCard}>
          <div style={styles.sectionHeader}>
            <h3 style={styles.sectionTitle}>Booking Orders</h3>
            <span style={styles.sectionPill}>Live Requests</span>
          </div>

          {loadingOrders ? (
            <p style={styles.emptyText}>Loading orders...</p>
          ) : orders.length > 0 ? (
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>PID</th>
                    <th style={styles.th}>Date</th>
                    <th style={styles.th}>Time</th>
                    <th style={styles.th}>City</th>
                    <th style={styles.th}>Area</th>
                    <th style={styles.th}>Service Category</th>
                    <th style={styles.th}>Service Type</th>
                    <th style={styles.th}>Service List</th>
                    <th style={styles.th}>Price</th>
                    <th style={styles.th}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((job, index) => (
                    <tr key={job.order_id || index}>
                      <td style={styles.td}>{job.pid || '-'}</td>
                      <td style={styles.td}>{job.date || '-'}</td>
                      <td style={styles.td}>{job.time || '-'}</td>
                      <td style={styles.td}>
                        <FaMapMarkerAlt className="me-2" color="#ef4444" />
                        {job.city || '-'}
                      </td>
                      <td style={styles.td}>{job.area || '-'}</td>
                      <td style={styles.td}>{job.service_category || '-'}</td>
                      <td style={styles.td}>{job.service_type || '-'}</td>
                      <td style={styles.td}>
                        <div>{safeJoin(job.service_list)}</div>
                        {Array.isArray(job.detailed_service_list) && job.detailed_service_list.length > 0 && (
                          <ul style={styles.subList}>
                            {job.detailed_service_list.map((item, idx) => (
                              <li key={`${item.value || idx}-${idx}`}>
                                {item.label || item.value} - {formatPrice(item.line_total || item.price)}
                              </li>
                            ))}
                          </ul>
                        )}
                      </td>
                      <td style={styles.td}>
                        <span style={styles.priceText}>{formatPrice(job.initial_service_charge)}</span>
                      </td>
                      <td style={styles.td}>
                        <div className="d-flex gap-2 flex-wrap">
                          <button
                            style={styles.acceptBtn}
                            onClick={() => handleOrderAction(job, 'accept')}
                          >
                            <FaCheckCircle className="me-1" />
                            Accept
                          </button>
                          <button
                            style={styles.rejectBtn}
                            onClick={() => handleOrderAction(job, 'reject')}
                          >
                            <FaTimesCircle className="me-1" />
                            Reject
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p style={styles.emptyText}>No booking orders found.</p>
          )}
        </div>

        <div style={styles.sectionCard}>
          <div style={styles.sectionHeader}>
            <h3 style={styles.sectionTitle}>Order History</h3>
            <span style={{ ...styles.sectionPill, background: '#ecfdf5', color: '#047857' }}>
              Active Jobs
            </span>
          </div>

          {loadingHistory ? (
            <p style={styles.emptyText}>Loading order history...</p>
          ) : orderHistory.length > 0 ? (
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>PID</th>
                    <th style={styles.th}>Date</th>
                    <th style={styles.th}>Time</th>
                    <th style={styles.th}>City</th>
                    <th style={styles.th}>Area</th>
                    <th style={styles.th}>Service Category</th>
                    <th style={styles.th}>Service Type</th>
                    <th style={styles.th}>Service List</th>
                    <th style={styles.th}>Price</th>
                    <th style={styles.th}>Customer Mobile</th>
                    <th style={styles.th}>Status</th>
                    <th style={styles.th}>Work Status</th>
                  </tr>
                </thead>
                <tbody>
                  {orderHistory.map((job, index) => {
                    const workAction = getWorkAction(job);
                    const canShowCancel = ['2', '777'].includes(String(job.status));
                    const cancelValidation = getCancelValidation(job);

                    return (
                      <tr key={job.order_id || index}>
                        <td style={styles.td}>{job.pid || '-'}</td>
                        <td style={styles.td}>{job.date || '-'}</td>
                        <td style={styles.td}>{job.time || '-'}</td>
                        <td style={styles.td}>{job.city || '-'}</td>
                        <td style={styles.td}>{job.area || '-'}</td>
                        <td style={styles.td}>{job.service_category || '-'}</td>
                        <td style={styles.td}>{job.service_type || '-'}</td>
                        <td style={styles.td}>{safeJoin(job.service_list)}</td>
                        <td style={styles.td}>
                          <span style={styles.priceText}>
                            {formatPrice(job.initial_service_charge || job.service_charge)}
                          </span>
                        </td>
                        <td style={styles.td}>{job.mobile || '-'}</td>
                        <td style={styles.td}>{getHistoryStatusBadge(job)}</td>
                        <td style={styles.td}>
                          <div className="d-flex gap-2 flex-wrap">
                            {workAction.type === 'start' ? (
                              <button
                                style={{
                                  ...styles.startBtn,
                                  opacity: workAction.disabled ? 0.6 : 1,
                                  cursor: workAction.disabled ? 'not-allowed' : 'pointer',
                                }}
                                disabled={workAction.disabled}
                                title={workAction.message || 'Start work'}
                                onClick={() => {
                                  if (workAction.disabled) {
                                    alert(workAction.message);
                                    return;
                                  }
                                  handleWorkStatus(job, 'start');
                                }}
                              >
                                <FaPlayCircle className="me-1" />
                                Start
                              </button>
                            ) : workAction.type === 'stop' ? (
                              <button
                                style={styles.stopBtn}
                                onClick={() => handleWorkStatus(job, 'stop')}
                              >
                                <FaStopCircle className="me-1" />
                                Stop
                              </button>
                            ) : workAction.type === 'completed' ? (
                              <span style={styles.completedText}>Completed</span>
                            ) : (
                              <span style={styles.waitingText}>-</span>
                            )}

                            {canShowCancel && (
                              <button
                                style={{
                                  ...styles.cancelBtn,
                                  opacity: cancelValidation.allowed ? 1 : 0.6,
                                  cursor: cancelValidation.allowed ? 'pointer' : 'not-allowed',
                                }}
                                disabled={!cancelValidation.allowed}
                                title={cancelValidation.message || 'Cancel order'}
                                onClick={() => {
                                  if (!cancelValidation.allowed) {
                                    alert(cancelValidation.message);
                                    return;
                                  }
                                  handleCancelOrder(job);
                                }}
                              >
                                <FaTimesCircle className="me-1" />
                                Cancel
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <p style={styles.emptyText}>No order history found.</p>
          )}
        </div>

        <div style={styles.sectionCard}>
          <div style={styles.sectionHeader}>
            <h3 style={styles.sectionTitle}>Old Order History</h3>
            <span style={{ ...styles.sectionPill, background: '#fff7ed', color: '#c2410c' }}>
              Completed / Cancelled
            </span>
          </div>

          {loadingOldHistory ? (
            <p style={styles.emptyText}>Loading old order history...</p>
          ) : oldOrderHistory.length > 0 ? (
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>PID</th>
                    <th style={styles.th}>Date</th>
                    <th style={styles.th}>Time</th>
                    <th style={styles.th}>City</th>
                    <th style={styles.th}>Area</th>
                    <th style={styles.th}>Service Category</th>
                    <th style={styles.th}>Service Type</th>
                    <th style={styles.th}>Service List</th>
                    <th style={styles.th}>Price</th>
                    <th style={styles.th}>Customer Mobile</th>
                    <th style={styles.th}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {oldOrderHistory.map((job, index) => (
                    <tr key={job.order_id || index}>
                      <td style={styles.td}>{job.pid || '-'}</td>
                      <td style={styles.td}>{job.date || '-'}</td>
                      <td style={styles.td}>{job.time || '-'}</td>
                      <td style={styles.td}>{job.city || '-'}</td>
                      <td style={styles.td}>{job.area || '-'}</td>
                      <td style={styles.td}>{job.service_category || '-'}</td>
                      <td style={styles.td}>{job.service_type || '-'}</td>
                      <td style={styles.td}>{safeJoin(job.service_list)}</td>
                      <td style={styles.td}>
                        <span style={styles.priceText}>
                          {formatPrice(job.initial_service_charge || job.service_charge)}
                        </span>
                      </td>
                      <td style={styles.td}>{job.mobile || '-'}</td>
                      <td style={styles.td}>
                        {String(job.status) === '8' ? (
                          <span style={styles.statusCompleted}>Work Completed</span>
                        ) : ['10', '11'].includes(String(job.status)) ? (
                          <span style={styles.statusCancelled}>Cancelled</span>
                        ) : (
                          <span style={styles.waitingText}>{job.status || '-'}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p style={styles.emptyText}>No old order history found.</p>
          )}
        </div>
      </div>

      {showModal && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalBox}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Claim Credit</h5>
              <button className="btn-close" onClick={() => setShowModal(false)}></button>
            </div>

            <p className="mb-3">
              You are claiming <strong>{Total_credit_Point}</strong> points
            </p>

            <input
              type="text"
              placeholder="Account Holder Name"
              name="accountHolder"
              value={bankDetails.accountHolder}
              onChange={handleInputChange}
              style={styles.input}
            />
            <input
              type="text"
              placeholder="Bank Name"
              name="bankName"
              value={bankDetails.bankName}
              onChange={handleInputChange}
              style={styles.input}
            />
            <input
              type="text"
              placeholder="Account Number"
              name="accountNumber"
              value={bankDetails.accountNumber}
              onChange={handleInputChange}
              style={styles.input}
            />
            <input
              type="text"
              placeholder="IFSC Code"
              name="ifscCode"
              value={bankDetails.ifscCode}
              onChange={handleInputChange}
              style={styles.input}
            />

            <div style={styles.modalFooter}>
              <button style={styles.secondaryBtn} onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button style={styles.primaryBtn} onClick={handleClaimSubmit}>
                Submit Claim
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LabourDashboard;